var map = {
	"./Forbes_logo.png": "147b",
	"./IIM-04.png": "27db",
	"./PayUFinance.svg": "8560",
	"./Techcrunch_logo.png": "7f23",
	"./Verve_logo.png": "4974",
	"./Wharton.png": "daf0",
	"./accion.png": "6384",
	"./acumen.png": "0764",
	"./angel_list.png": "32d7",
	"./arthmate.webp": "c447",
	"./bain.png": "f1fd",
	"./business_line.png": "30b3",
	"./business_standard.png": "3e71",
	"./business_world.png": "51dd",
	"./bw_disrupt.png": "a515",
	"./capital_one.png": "6c08",
	"./cnbc-logo.jpg": "3a07",
	"./college.png": "037a",
	"./crunchbase.png": "4436",
	"./deutache.png": "7c76",
	"./disrupt.png": "2eaa",
	"./economic_times.png": "4cc3",
	"./et_rise.png": "4d35",
	"./et_tech.png": "cd5f",
	"./facebook.png": "083a",
	"./financial_express.png": "c621",
	"./flexi_new_header.svg": "ec74",
	"./free_press.png": "7003",
	"./ftcashFinance.png": "91e2",
	"./ftcashFinance1.png": "0e12",
	"./grant_thorton.png": "cd3a",
	"./gromor.png": "1930",
	"./harvard.png": "525f",
	"./hindu.png": "5c4d",
	"./ibm.png": "3927",
	"./ibm_smart_camp.png": "0cec",
	"./iim_ahmedabad.png": "66d1",
	"./inc_42.png": "7af3",
	"./innovation_hub.png": "5079",
	"./isb.png": "b305",
	"./kellogg_logo.png": "3b8f",
	"./kpmg.png": "6694",
	"./kpmg_100.png": "5173",
	"./leland.png": "d47d",
	"./lgt.png": "3210",
	"./live_mint.png": "6f73",
	"./mBillionth.png": "b710",
	"./massachusetts.png": "cd09",
	"./mastercard.png": "05ae",
	"./medianama.png": "4488",
	"./midday.png": "7b68",
	"./mit.png": "7c48",
	"./nasscom.png": "7abc",
	"./nasscom_awards_2019.png": "a3a4",
	"./nasscom_emerge.png": "3613",
	"./nasscom_retech.png": "d01e",
	"./ndtv_real_deal.png": "b64e",
	"./nikkei.png": "82b5",
	"./ntt_data.png": "08b2",
	"./ntt_data_innovation.png": "9154",
	"./owler.png": "ef86",
	"./panacea.png": "aff6",
	"./paypal.png": "3292",
	"./paypal_logo.png": "aae0",
	"./pci_dss.png": "3d8f",
	"./pitch_rb.png": "6a36",
	"./red_herring_asia.png": "99ba",
	"./sankalp_global_summit.png": "0dd8",
	"./singapore.png": "8ba4",
	"./stanford.png": "e990",
	"./stashfin.png": "b5a7",
	"./tech_circle.png": "e043",
	"./the_fintech_20.png": "7983",
	"./times_of_india.png": "5efd",
	"./transunion.jpg": "a051",
	"./ugro.png": "eb05",
	"./uk_trade.png": "1d41",
	"./uniliver.png": "8a1c",
	"./vccircle.png": "affc",
	"./village_capital.png": "fc2b",
	"./wall_street_logo.png": "c071",
	"./world_bank.png": "4f19",
	"./your_story.png": "4f9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";